"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIFormComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const events_1 = require("../form-parts/events");
//@ts-ignore                
let rwsTemplate = T.html `<form @submit="${(x, c) => x.handleSubmit(c.event)}" class="ai-form">
    ${T.repeat(x => x.data.fields || [], T.html `
        <div class="ai-form-field">
            ${T.when(x => x.type === 'input', T.html `
                <part-input 
                    name="${x => x.name}" 
                    label="${x => x.label}" 
                    placeholder="${x => x.placeholder || ''}"
                    type="${x => x.fieldType || 'text'}"
                    ?required="${x => x.required === 'true'}"
                ></part-input>
            `)}
            ${T.when(x => x.type === 'textarea', T.html `
                <part-textarea 
                    name="${x => x.name}" 
                    label="${x => x.label}" 
                    placeholder="${x => x.placeholder || ''}"
                    rows="${x => x.rows || '3'}"
                    ?required="${x => x.required === 'true'}"
                ></part-textarea>
            `)}
            ${T.when(x => x.type === 'select', T.html `
                <part-select 
                    name="${x => x.name}" 
                    label="${x => x.label}" 
                    placeholder="${x => x.placeholder || ''}"
                    :options="${x => x.options || []}"
                    ?multiple="${x => x.multiple}"
                    ?required="${x => x.required === 'true'}"
                ></part-select>
            `)}
            ${T.when(x => x.type === 'radio', T.html `
                <part-radio 
                    name="${x => x.name}" 
                    label="${x => x.label}" 
                    :options="${x => x.options || []}"
                    ?required="${x => x.required === 'true'}"
                ></part-radio>
            `)}
            ${T.when(x => x.type === 'checkbox', T.html `
                <part-checkbox 
                    name="${x => x.name}" 
                    label="${x => x.label}" 
                    :options="${x => x.options || []}"
                    ?multiple="${x => x.multiple}"
                    ?required="${x => x.required === 'true'}"
                ></part-checkbox>
            `)}
            ${T.when(x => x.type === 'date', T.html `
                <part-date 
                    name="${x => x.name}" 
                    label="${x => x.label}" 
                    placeholder="${x => x.placeholder || ''}"
                    min="${x => x.min || ''}"
                    max="${x => x.max || ''}"
                    ?required="${x => x.required === 'true'}"
                ></part-date>
            `)}
            ${T.when(x => x.type === 'switch', T.html `
                <part-switch 
                    name="${x => x.name}" 
                    label="${x => x.label}" 
                ></part-switch>
            `)}
            ${T.when(x => x.type === 'slider', T.html `
                <part-slider 
                    name="${x => x.name}" 
                    label="${x => x.label}" 
                    min="${x => x.min || '0'}"
                    max="${x => x.max || '100'}"
                    step="${x => x.step || '1'}"
                    unit="${x => x.unit || ''}"
                    showValue="${x => x.showValue || 'true'}"
                    ?required="${x => x.required === 'true'}"
                ></part-slider>
            `)}
        </div>
    `)}
    <div class="ai-form-actions">
        <button type="submit" class="btn btn-primary">${x => x.data.submitLabel || (x.data.quiz ? 'tutorial.form.editor.defaultQuizSubmitLabel'.t() : 'tutorial.form.editor.defaultSubmitLabel'.t())}</button>
    </div>
</form>
`;
require("./styles/layout.scss");
const styles = T.css `.ai-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.ai-form .ai-form-field {
  width: 100%;
}
.ai-form .ai-form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}
.ai-form .ai-form-actions button[type=submit] {
  padding: 0.5rem 1.5rem;
}`;
const shadowOptions = { "mode": "open" };
let AIFormComponent = class AIFormComponent extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.data = {};
        this.formValues = {};
    }
    connectedCallback() {
        super.connectedCallback();
        this.on(events_1.inputEvents.changed, (event) => {
            this.formValues[event.detail.fieldName] = event.detail.value;
        });
    }
    handleSubmit(event) {
        event.preventDefault();
        if (!this.validateRequiredFields()) {
            console.warn('AIForm: required fields are missing');
            return;
        }
        const xml = this.buildToolDataXml();
        window.dispatchEvent(new CustomEvent('ai-chat:tool:added', {
            detail: {
                toolName: 'ai-form',
                xml,
                values: { ...this.formValues }
            },
            bubbles: true,
            composed: true
        }));
    }
    validateRequiredFields() {
        const fields = this.data.fields || [];
        for (const field of fields) {
            if (field.required === 'true') {
                const value = this.formValues[field.name];
                if (value === undefined ||
                    value === '' ||
                    value === null ||
                    (Array.isArray(value) && value.length === 0)) {
                    return false;
                }
            }
        }
        return true;
    }
    buildToolDataXml() {
        const entries = Object.entries(this.formValues)
            .map(([key, value]) => {
            return `<tool-data-entry key="${this.escapeXml(key)}">${this.escapeXml(this.formatValue(value))}</tool-data-entry>`;
        })
            .join('\n');
        return `<tool-data toolName="ai-form">\n${entries}\n</tool-data>`;
    }
    formatValue(value) {
        if (value === null || value === undefined) {
            return '';
        }
        if (Array.isArray(value)) {
            return value.join(', ');
        }
        if (typeof value === 'object') {
            return JSON.stringify(value);
        }
        return String(value);
    }
    escapeXml(unsafe) {
        return unsafe.replace(/[<>&'"]/g, (c) => {
            switch (c) {
                case '<': return '&lt;';
                case '>': return '&gt;';
                case '&': return '&amp;';
                case "'": return '&apos;';
                case '"': return '&quot;';
                default: return c;
            }
        });
    }
};
exports.AIFormComponent = AIFormComponent;
__decorate([
    client_1.jsonAttr,
    __metadata("design:type", Object)
], AIFormComponent.prototype, "data", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], AIFormComponent.prototype, "formValues", void 0);
exports.AIFormComponent = AIFormComponent = __decorate([
    (0, client_1.RWSView)('ai-form', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], AIFormComponent);
AIFormComponent.defineComponent();
